import * as resolvers from 'app/infrastructure/ui/renderer/resolvers';
import { ComplexValue, ValueProperty } from 'ui';

export const connectedCasesIntegrityValues = (caseState, uiEngineProps) => ({  
  connectedIntegrityStatus: resolvers.getComponentValues(caseState, uiEngineProps, 'ConnectedIntegrityStatus').valueItem,
  connectedIntegrityScore: resolvers.getComponentValues(caseState, uiEngineProps, 'ConnectedIntegrityScore').value
});

export interface ConnectedCasesIntegrityValueShape {  
  connectedIntegrityStatus: ComplexValue<number>;
  connectedIntegrityScore: ValueProperty;
  connectedIntegrityStatusBarrierEval: ComplexValue<number>;  
}

export const connectedCasesintegrityStatusBarrierEvalValues = (caseState, uiEngineProps) => ({
  integrityStatusBarrierEval: resolvers.getComponentValues(caseState, uiEngineProps, 'IntegrityStatusBarrierEva').valueItem  
});
